<template>
    <div>
        <br/>
        <nav v-on:keypress.enter.prevent="searchInsurance" class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input v-model="search.driver"
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder="ชื่อคนขับ"
                            aria-label="Search"/>
                    <button @click="searchInsurance"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                    <button @click="InsuranceFeeTotal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="pencil-alt"></icon>
                        แก้ไขเงินประกัน
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">สถานะการจ่าย</th>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ยอดเงินสะสม</th>
                    <th scope="col">ดูข้อมูลการจ่าย</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in insurance_driver">
                    <td>
                        <template v-if="!data.insurance_fee_status">
                            <icon name="circle" style="color: red"></icon>
                        </template>
                        <template v-else>
                            <icon name="circle" style="color: green"></icon>
                        </template>
                    </td>
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>
                        <template v-if="data.insurance_fee_total">
                            {{data.insurance_fee_total | currency}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <button @click="showInsuranceData(data.id)"
                                class="btn btn-default next">
                            <icon name="eye"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="insurance_driver.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverPage">
            </vue-pagination>
        </div>
        <br/>
        <!--modal edit--->
        <b-modal hide-footer hide-header ref="edit_data">
            <div>
                <insurance-modal @submit="saveInsuranceFee">
                </insurance-modal>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
            <div>
                <loading @submit="hideLoadingModal" :msg="msg" :status="loading_status"></loading>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ dataPaginate }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import InsuranceModal from "./InsuranceModal";
    import {
        canViewDriver,
        canViewDriverAll,
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";
    export default {
        components: {
            Loading,
            InsuranceModal,
            VuePagination},
        name: "insurance-list",
        data(){
            return {
                event_submit : false,
                msg : '',
                loading_status : 1,
            }
        },
        created(){
            this.$store.dispatch('InsuranceFee/setInsuranceFee');
            this.$store.dispatch('InsuranceFee/clearSearch');
        },
        computed:{
            canViewDriver,
            canViewDriverAll,
            ...mapState({
                insurance_driver:state=>{
                    return state.InsuranceFee.insurance_fee
                },
                dataPaginate:state=>{
                    return state.InsuranceFee.dataPaginate
                },
                search :state=>{
                    return state.InsuranceFee.search;
                }

            })
        },
        methods:{
            showEditInsuranceModal(){
               this.$refs.edit_data.show();
            },
            hideEditInsuranceModal(){
                this.$refs.edit_data.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            saveInsuranceFee(submit){
                if(submit){
                    this.$store.dispatch('InsuranceFee/editInsuranceFee',submit)
                        .then(()=>{
                            this.hideEditInsuranceModal();
                            this.$store.dispatch('InsuranceFee/setInsuranceFee');
                        })
                }
                this.hideEditInsuranceModal();
            },
            showInsuranceData(id){
                if(id){
                    this.showLoadingModal();
                    this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
                    this.$store.dispatch('Driver/getDriverById',id)
                        .then(()=>{
                            this.$store.dispatch("InsuranceFee/showInsurance",{
                               driver_id : id,
                               page : 1,
                            }).then(()=>{
                                let route = this.$router.resolve({
                                    name: "insurance-information",
                                });
                                window.open(route.href,'_blank');
                                this.hideLoadingModal();
                            })
                        });
                }
            },
            searchInsurance(){
                this.event_submit = true;
                this.$store.dispatch('InsuranceFee/searchInsurance',{
                    driver : this.search.driver
                })
            },
            getDriverPage(){
                const page = this.dataPaginate.current_page;
                if(this.event_submit){
                    this.$store.dispatch('InsuranceFee/searchInsurance',{
                        page : page,
                        driver : this.search.driver
                    })
                }
                else{
                    this.$store.dispatch('InsuranceFee/setInsuranceFee',page);
                }
            },
            InsuranceFeeTotal(){
                this.$store.dispatch("InsuranceFee/getInsuranceTotal").then(()=>{
                    this.showEditInsuranceModal();
                });
            }
        }
    }
</script>

<style scoped>

</style>
